// Lightgallery

import lightGallery from "lightgallery";
import lgVideo from "lightgallery/plugins/video";

const lightGallerySingle = () => {
  var lgallery = document.getElementById("lightgallery");

  if (lgallery) {
    lightGallery(document.getElementById("lightgallery"), {
      speed: 500,
      mode: "lg-fade",
    });
  }
};

export { lightGallerySingle };

const lightGalleryVideo = () => {
  var lightvideo = document.getElementById("lightgalleryvideo");

  if (lightvideo) {
    lightGallery(document.getElementById("lightgalleryvideo"), {
      speed: 500,
      plugins: [lgVideo],
    });
  }
};

export { lightGalleryVideo };

const lightGalleryMutiple = () => {
  var elements = document.getElementsByClassName("lightgallery-gallery");

  for (let item of elements) {
    const galleryInstance = lightGallery(item, {
      plugins: [lgVideo],
    });
  }
};

export { lightGalleryMutiple };
